import LegalPage from "@/pages/LegalPage";

export default function Privacy() {
  return <LegalPage slug="privacy" fallbackTitle="Privacy Policy" />;
}
